(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  /* Mete 2026-09-10: the footer's region chip opens on click too (hover still works), holds until a
     click lands outside it or Escape, and Enter / Space toggle it - the nav drawer chip's behaviour
     (snippets/umbra-ovo-header-js.liquid), delegated so a section re-render in the editor keeps it.
     The list opens UPWARDS: assets/umbra-footer.css. */
  (function () {
    var SEL = '.umbra-footer__store .store__selector';
    var setOpen = function (box, open) {
      box.classList.toggle('is-open', open);
      var chip = box.querySelector('.current-store-title');
      if (chip) chip.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { box.classList.remove('is-dismissed'); return; }
      /* closing while the pointer or focus is still on the chip: is-dismissed hides the list past :hover
         until the pointer leaves, and the chip gives up focus so the list does not spring back */
      box.classList.add('is-dismissed');
      if (chip && document.activeElement === chip) chip.blur();
      var clear = function () { box.classList.remove('is-dismissed'); box.removeEventListener('mouseleave', clear); };
      box.addEventListener('mouseleave', clear);
    };
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var chip = t.closest(SEL + ' .current-store-title');
      if (chip) { var box = chip.closest(SEL); setOpen(box, !box.classList.contains('is-open')); return; }
      var open = document.querySelector(SEL + '.is-open');
      if (open && !open.contains(t)) setOpen(open, false);
    });
    document.addEventListener('keydown', function (e) {
      var open = document.querySelector(SEL + '.is-open');
      if (e.key === 'Escape' && open) { setOpen(open, false); return; }
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var t = e.target;
      if (!t || !t.closest || !t.closest(SEL + ' .current-store-title')) return;
      e.preventDefault();
      var box = t.closest(SEL);
      setOpen(box, !box.classList.contains('is-open'));
    });
  })();

  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        this.klaviyoForm = this.querySelector('#klaviyo-signup_form');
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));

         if (this.klaviyoForm) {
          this.klaviyoInput = this.klaviyoForm.querySelector('[name="klaviyo[email]"]');
          this.successAlert = this.klaviyoForm.querySelector('#klaviyo-signup-success');
          this.errorAlert = this.klaviyoForm.querySelector('#klaviyo-signup-error');
          this.klaviyoBusy = false;
          this.klaviyoForm.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter || this.disclosure.hasAttribute('data-open-mobile');

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleSubmit(evt) {
        evt.preventDefault();
        if (this.klaviyoBusy) return;
        this.klaviyoBusy = true;
        /* ids come from snippets/umbra-klaviyo-ids.liquid, the same map the popup reads; with no ids the form shows its error state and sends nothing */
        const ids = this.closest('[data-kl-list]');
        const company_id = (ids && ids.dataset.klCompany) || '';
        const list_id = (ids && ids.dataset.klList) || '';

        const url = `https://a.klaviyo.com/client/subscriptions?company_id=${company_id}`;
        const options = {
          method: 'POST',
          headers: { revision: '2024-10-15', 'content-type': 'application/vnd.api+json' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: `${this.klaviyoInput.value}`,
                    },
                  },
                },
              },
              relationships: { list: { data: { type: 'list', id: `${list_id}` } } },
            },
          }),
        };

        (company_id && list_id ? fetch(url, options) : Promise.reject(new Error('no klaviyo ids')))
          .then((res) => {
            // Only a 2xx answer from Klaviyo is a subscription; anything else is an error.
            if (!res.ok) throw new Error(res.status);
            if (this.successAlert) {
              setTimeout(() => {
                this.successAlert.hidden = false;
              }, 1000);

              setTimeout(() => {
                this.successAlert.hidden = true;
                this.klaviyoForm.reset();
              }, this.successAlert.dataset.visibleFor);
            }
          })
          .catch(() => {
            if (this.errorAlert) {
              this.errorAlert.hidden = false;
              setTimeout(() => {
                this.errorAlert.hidden = true;
              }, this.errorAlert.dataset.visibleFor);
            }
          })
          .finally(() => {
            this.klaviyoBusy = false;
          });
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
